import { render, staticRenderFns } from "./aiCustomPageDetail.vue?vue&type=template&id=243d8fec&scoped=true&"
import script from "./aiCustomPageDetail.vue?vue&type=script&lang=js&"
export * from "./aiCustomPageDetail.vue?vue&type=script&lang=js&"
import style0 from "./aiCustomPageDetail.vue?vue&type=style&index=0&id=243d8fec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "243d8fec",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('243d8fec')) {
      api.createRecord('243d8fec', component.options)
    } else {
      api.reload('243d8fec', component.options)
    }
    module.hot.accept("./aiCustomPageDetail.vue?vue&type=template&id=243d8fec&scoped=true&", function () {
      api.rerender('243d8fec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/SystemMaintenance/components/aiCustomPage/aiCustomPageDetail.vue"
export default component.exports